<div class=" dcp-custom-form dcp p-2">
    <div class="d-flex align-items-center justify-content-between mb-3 border-bottom pb-2">
        <h2 class="mb-0">{{ data.title}}</h2>
        <div class="btn-light btn-position" (click)="!isLoading && actionModal()" [class.disabled]="isLoading"> <span
                class="mat-icon material-icons ">close</span></div>
    </div>

    <p>{{ data.message}} </p>
    <div class="d-flex justify-content-end align-items-center mt-4">
        <button class="btn btn-outline-primary mr-2" (click)="actionModal()">Cancel</button>
        <button class="btn btn-primary" (click)="actionModal(true)">{{ data.button}}</button>
    </div>

</div>
